import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedWomenIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1.5C13.8783 1.5 15.6171 2.51374 16.9033 4.22852C18.1896 5.9436 19 8.3363 19 11C19 13.6637 18.1896 16.0564 16.9033 17.7715C15.6171 19.4863 13.8783 20.5 12 20.5C10.1217 20.5 8.38286 19.4863 7.09668 17.7715C5.81037 16.0564 5 13.6637 5 11C5 8.3363 5.81037 5.9436 7.09668 4.22852C8.38286 2.51374 10.1217 1.5 12 1.5Z",
			fill: "#4BBFDA",
			stroke: "#007AAF",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9014 15.5C18.0948 16.3575 20.0761 18.2783 21.0146 20.9619C21.2712 21.6954 20.6789 22.5 19.7344 22.5H4.26562C3.32142 22.5 2.72783 21.6958 2.9834 20.9609C3.91542 18.2809 5.88125 16.3662 8.09863 15.5H15.9014Z",
			fill: "#4BBFDA",
			stroke: "#007AAF",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 13.5C14.1326 13.5 14.2598 13.5528 14.3535 13.6465C14.4473 13.7403 14.5 13.8674 14.5 14V13.9971L14.501 14.0117C14.5021 14.0293 14.5048 14.0601 14.5107 14.1016C14.5226 14.1847 14.5477 14.3111 14.5996 14.4668C14.703 14.7769 14.9146 15.2076 15.3535 15.6465C16.0248 16.3177 15.9981 17.2659 15.875 17.9209C15.6764 18.977 14.676 19.5 13.7637 19.5H10.2363C9.32404 19.5 8.32358 18.977 8.125 17.9209C8.00187 17.2659 7.97533 16.3177 8.64648 15.6465C9.08539 15.2075 9.29701 14.777 9.40039 14.4668C9.45228 14.3111 9.47736 14.1847 9.48926 14.1016C9.49518 14.0601 9.49785 14.0293 9.49902 14.0117L9.5 13.9971V14C9.5 13.7239 9.72391 13.5001 10 13.5H14Z",
			fill: "white",
			stroke: "#007AAF",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3.5C13.0996 3.5 14.1187 3.92025 14.8555 4.78711C15.5863 5.64711 16 6.89894 16 8.5C16 10.0991 15.5882 11.5702 14.8965 12.6572C14.2085 13.7384 13.1967 14.5 12 14.5C10.8033 14.5 9.79152 13.7384 9.10352 12.6572C8.41178 11.5702 8 10.0991 8 8.5C8 6.89894 8.41369 5.64711 9.14453 4.78711C9.88131 3.92025 10.9004 3.5 12 3.5Z",
			fill: "white",
			stroke: "#007AAF",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 2.5L8 4.5L9 6L14 8L18 9.00012L16.5 5L14.5 3L12 2L10.5 2.5Z",
			fill: "#4BBFDA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 4C8 5.99988 11 7.49988 15 8C17.4143 8.30186 18.5 10.4999 19 11.9999",
			stroke: "#007AAF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 18.0625,
			cy: 18.0373,
			rx: 4.0625,
			ry: 4.03728,
			fill: "white",
			stroke: "#007AAF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1875 21.1426L24 23.9376",
			stroke: "#007AAF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedWomenIcon);
const Memo = memo(ForwardRef);
export default Memo;
